/**
 * Mobile Bottom Navigation.
 *
 * Fixed bottom tab bar visible only on small screens. Provides quick
 * access to the most-used features: Dashboard, Inventory, Scan, Work
 * Orders, and Sales.
 */

import { Link, useLocation } from "react-router-dom";
import { clsx } from "clsx";
import {
  LayoutDashboard,
  Package,
  ScanLine,
  Wrench,
  ShoppingCart,
} from "lucide-react";

const tabs = [
  { label: "Home", path: "/", icon: LayoutDashboard },
  { label: "Inventory", path: "/inventory", icon: Package },
  { label: "Scan", path: "/scan", icon: ScanLine },
  { label: "Work Orders", path: "/work-orders", icon: Wrench },
  { label: "Sales", path: "/sales", icon: ShoppingCart },
];

function MobileNav() {
  const location = useLocation();

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 border-t border-[var(--border-default)] bg-[var(--surface-base)] lg:hidden">
      <div className="flex items-center justify-around">
        {tabs.map((tab) => {
          const isActive =
            tab.path === "/"
              ? location.pathname === "/"
              : location.pathname.startsWith(tab.path);

          return (
            <Link
              key={tab.path}
              to={tab.path}
              className={clsx(
                "flex flex-1 flex-col items-center gap-0.5 py-2 text-[10px] font-medium transition-colors",
                isActive
                  ? "text-[var(--color-interactive-primary)]"
                  : "text-[var(--text-tertiary)]",
                tab.path === "/scan" && "relative",
              )}
            >
              {tab.path === "/scan" ? (
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-[var(--color-interactive-primary)] text-white shadow-lg -mt-5">
                  <tab.icon className="h-5 w-5" />
                </div>
              ) : (
                <tab.icon className="h-5 w-5" />
              )}
              <span>{tab.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}

export default MobileNav;
